import type { FaireProductEntity } from "../../entity_types/product";

export const p_6bduf22m2v: FaireProductEntity = {
  token: "p_6bduf22m2v",
  type: "product",
  name: "Thank You Card by Love Julia—Thanks Soooo Much (Thumbs Up)",
  brandToken: "b_7z2alyc1",
  brandName: "And Here We Are",
  imageUrl:
    "https://cdn.faire.com/fastly/17f6f1065d405562ba5f7aa26420da2c88da4fe4b3c805222d2adea15ce99bf4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c739cfe146f3d411b53f692900d7b94c13cbfbffcabb1222c6741eae1110356b.jpeg",
    "https://cdn.faire.com/fastly/8b8aff1871c808a88baf70befe3cd00cf66ca1c14f3d97f5ff49b2280fe2ca5e.jpeg",
  ],
  priceDollars: 3,
  description:
    "This best-selling modern thank you greeting card from 'Love Julia for And Here We Are'  features a fun hand drawn illustration in black and white of a long, winding arm with a thumbs up, and reads, \"thank you soooooooooooo much\" Digitally printed on luxe felt paper in the USA, blank inside. ",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:34.339Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
